import React from 'react16';
import proptypes from 'prop-types';

export const PropTypes = proptypes;
export * from 'react16';
export default React;
